import React, { useEffect } from "react";
import AppRoutes from "./router/routes";
import { ToastContainer } from "react-toastify";
import { useAuthStore } from "./stores/authStore";
import GlobalLoading from "./pages/loading";
import { TokenHelper } from "./utils/tokensHelper";
import { useGetProfile, useRefreshToken } from "./api/AuthApi";

const App: React.FC = () => {
  const { user, loading, setLoading } = useAuthStore();
  const tokenHelper = new TokenHelper();
  const { refresh } = tokenHelper.getTokens();
  const { refreshToken } = useRefreshToken();
  const { getProfile } = useGetProfile();

  useEffect(() => {
    const sessionManager = async () => {
      console.log("Initial user:", user);
      console.log("Initial refresh token:", refresh);

      // If there's no refresh token and no user, stop here
      if (!refresh && !user) {
        console.log("No refresh token and no user — not logged in.");
        setLoading(false);
        return;
      }

      // If user already exists, skip fetch
      if (refresh && user) {
        console.log("User already set, skipping session restore.");
        setLoading(false);
        return;
      }

      // If refresh exists but user is missing
      if (refresh && !user) {
        console.log("Restoring session...");

        try {
          const newTokens = await refreshToken();
          if (newTokens?.access) {
            await getProfile();
          }
        } catch (err) {
          console.error("Failed to restore session:", err);
        } finally {
          setLoading(false);
        }
      }
    };

    sessionManager();
  }, []);

  return loading ? (
    <GlobalLoading />
  ) : (
    <>
      <AppRoutes />
      <ToastContainer />
    </>
  );
};

export default App;
